$(document).ready(function() {
  var letters = "abcdefghijklmnop";

  function addClass($el, names) {
    $el.attr('class',
      [$el.attr('class')]
        .concat(names.trim().split(/\s+/))
        .filter(function(elem, pos, self) {
          return self.indexOf(elem) === pos;
        }).join(' '));
  }

  function removeClass($el, names) {
    var removedClasses = names.trim().split(/\s+/);
    $el.attr('class',
      $el.attr('class').split(/\s+/)
        .filter(function(name) {
          return removedClasses.indexOf(name) === -1;
        }).join(' '));
  }

  function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  function drawBarValue(event, chart, fill, decimals) {
    // If the draw event is for labels on the x-axis
    if(event.type === 'label' && event.axis.units.pos === 'x') {
      // If foreign object is NOT supported, we need to fallback to text-anchor and event.width / 2 offset.
      if(!chart.supportsForeignObject) {
        event.element.attr({
          x: event.x + event.width / 2,
          'text-anchor': 'middle'
        });
      }
    }

    // create a custom label element to insert into the bar
    if(event.type === 'bar') {

      var label = new Chartist.Svg("text");
      text = event.value.y.toString().replace('.', ',');
      if(decimals && text.indexOf(',') === -1) {
        text += ',0';
      }
      label.text(numberWithSpaces(text));
      label.attr({
          x: event.x1,
          y: event.y2 + 15,
          "text-anchor": "middle",
          style: "fill: "+fill+"; font-size: 11px;"
      });
      event.group.append(label);
    }
  }


  // Maksutulo
  if($('.chart-maksutulo').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [452.8, 470.2, 489.5, 508.9, 520.9]
        ]
      };
      var chart = new Chartist.Bar('.chart-maksutulo', data, {
        axisX: {
          showGrid: false
        }
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", true);});
    })();
  }

  // TyEL count
  if($('.chart-tyel-count').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [6791, 6931, 7041, 7134, 7315]
        ]
      };
      var chart = new Chartist.Bar('.chart-tyel-count', data, {
        axisX: {
          showGrid: false
        },
        low: 6600
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  if($('.chart-tyel-count-teaser').length) {
    (function(){
      var data = {
        labels: ['2016', '2017'],
        series: [
          [7134, 7315]
        ]
      };
      var chart = new Chartist.Bar('.chart-tyel-count-teaser', data, {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showLabel: false,
          offset: 0
        },
        low: 6600,
        chartPadding: 20
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  // TyEL person count
/*
  if($('.chart-tyel-persons').length) {
    (function(){
      var data = {
        labels: ['2011', '2012', '2013', '2014', '2015'],
        series: [
          [53339, 53817]
        ]
      };
      var chart = new Chartist.Bar('.chart-tyel-persons', data, {
        axisX: {
          showGrid: false
        }
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }
*/

  // TYEL Salary
  if($('.chart-tyel-salary').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [1601, 1597, 1627, 1692, 1709]
        ]
      };
      var chart = new Chartist.Bar('.chart-tyel-salary', data, {
        axisX: {
          showGrid: false
        },
        high: 1710,
        low: 1500,
        padding: 30,
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  // YEL count
  if($('.chart-yel-count').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [10870, 10739, 10735, 10457, 10265]
        ]
      };
      var chart = new Chartist.Bar('.chart-yel-count', data, {
        axisX: {
          showGrid: false
        }
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  if($('.chart-yel-count-teaser').length) {
    (function(){
      var data = {
        labels: ['2016', '2017'],
        series: [
          [10457, 10265]
        ]
      };
      var chart = new Chartist.Bar('.chart-yel-count-teaser', data, {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showLabel: false,
          offset: 0
        },
        low: 9000,
        chartPadding: 20
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  // YEL average-income
  if($('.chart-yel-average-income').length) {
    (function(){
      var data = {
        labels: ['2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017'],
        series: [
          [17192, 18478, 19083, 20885, 22110, 23008, 23819, 23814, 23953, 23546]
        ]
      };
      var chart = new Chartist.Bar('.chart-yel-average-income', data, {
        axisX: {
          showGrid: false
        },
        low: 10000,
        high: 25000
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  // YEL income
  if($('.chart-yel-income').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [252, 255, 256, 252, 242]
        ]
      };
      var chart = new Chartist.Bar('.chart-yel-income', data, {
        axisX: {
          showGrid: false
        },
        low: 200,
        high: 256
        //width: '500px'
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }

  // Pension shares
  if($('.chart-pensions').length) {
    (function(){
      var pension_labels = [
              '<span>80,6 %</span><br><span>Vanhuuseläke</span>',
              '<span>8,8 %</span><br><span>Työkyvyttömyyseläke</span>',
              '<span>10,4 %</span><br><span>Perhe-eläke</span>',
              '<span>0,3 %</span><br><span>Osa-aikaeläke</span>'
            ];

    	if($('body.sv').length) {
    		pension_labels = [
              '<span>80,6 % %</span><br><span>Ålderspension</span>',
              '<span>8,8 %</span><br><span>Invalidpension</span>',
              '<span>10,4 %</span><br><span>Familjepension</span>',
              '<span>0,3 %</span><br><span>Deltidspension</span>'
            ];
    	}

      var $chart_pensions = $('.chart-pensions'),
          $chart_pensions_legend = $('.chart-pensions-legend');

          var data = {
            labels: pension_labels,
            series: [80.6, 8.8, 10.4, 0.3]
          };

      new Chartist.Pie('.chart-pensions', data,  {
        chartPadding: 10,
        donut: true,
        donutWidth: 30,
        showLabel: false
      });

      $.each(data.labels, function(i, val) {
        var listItem = $('<li />')
            .addClass('ct-series-' + letters[i])
            .html(val)
            .appendTo($chart_pensions_legend);
      });

      $chart_pensions.on('mouseenter', '.ct-slice-donut', function() {
        var $slice = $(this),
            classes = $slice.parent().attr('class').split(' '),
            last = classes.slice(-1)[0];
            $chart_pensions_legend.find('.'+last).addClass('hover');
      });
      $chart_pensions.on('mouseleave', '.ct-slice-donut', function() {
        $chart_pensions_legend.find('li.hover').removeClass('hover');
      });

    })();
  }

  if($('.chart-pensions-modal').length) {
    (function(){
      var pension_labels = [
              'Vanhuuseläke: 25 145 / 80,6 %',
              'Työkyvyttömyyseläke: 2 741 / 8,8 %',
              'Perhe-eläke: 3 241 / 10,4 %',
              'Osittainen varhennettu vanhuuseläke: 327 / 1,1 %',
              'Osa-aikaeläke: 79 / 0,3 %'
            ];

    	if($('body.sv').length) {
    		pension_labels = [
              'Ålderspension: 25 145 / 80,6 %',
              'Invalidpension: 2 741 / 8,8 %',
              'Familjepension: 3 241 / 10,4 %',
              'Partiell förtida ålderspension: 327 / 1,1 %',
              'Deltidspension: 79 / 0,3 %'
            ];
    	}

      var $chart_pensions = $('.chart-pensions-modal'),
          $chart_pensions_legend = $('.chart-pensions-modal-legend');

          var data = {
            labels: pension_labels,
            series: [80.6, 8.8, 10.4, 0.3]
          };

      new Chartist.Pie('.chart-pensions-modal', data,  {
        chartPadding: 10,
        donut: true,
        donutWidth: 40,
        showLabel: false
      });

      $.each(data.labels, function(i, val) {
        var listItem = $('<li />')
            .addClass('ct-series-' + letters[i])
            .html(val)
            .appendTo($chart_pensions_legend);
      });

      $chart_pensions.on('mouseenter', '.ct-slice-donut', function() {
        var $slice = $(this),
            classes = $slice.parent().attr('class').split(' '),
            last = classes.slice(-1)[0];
            $chart_pensions_legend.find('.'+last).addClass('hover');
      });
      $chart_pensions.on('mouseleave', '.ct-slice-donut', function() {
        $chart_pensions_legend.find('li.hover').removeClass('hover');
      });

      $chart_pensions_legend.on('mouseenter', 'li', function() {
        var $item = $(this),
            last = $item.attr('class');
        addClass($chart_pensions.find('.'+last +' .ct-slice-donut'), 'hover');
      });
      $chart_pensions_legend.on('mouseleave', 'li', function() {
        removeClass($chart_pensions.find('.hover'), 'hover');
      });

    })();
  }

  // Chart customer shares
  if($('.chart-customer-shares').length) {
    (function(){
      var pension_labels = [
              'TyEL-vakuutetut: 53 503 / 57,0 %',
              'YEL-vakuutukset: 10 735 / 11,5 %',
              'Eläkkeensaajat: 29 560 / 31,6 %',
            ];

    	if($('body.sv').length) {
    		pension_labels = [
              'ArPL-försäkrade: 53 503 / 57,0 %',
              'FöPL-försäkringar: 10 735 / 11,5 %',
              'Pensionstagare: 29 560 / 31,6 %',
            ];
    	}

      var $chart_pensions = $('.chart-customer-shares'),
          $chart_pensions_legend = $('.chart-customer-shares-legend');

          var data = {
            labels: pension_labels,
            series: [57.0, 11.5, 31.6]
          };

      new Chartist.Pie('.chart-customer-shares', data,  {
        chartPadding: 10,
        donut: true,
        donutWidth: 40,
        showLabel: false
      });

      $.each(data.labels, function(i, val) {
        var listItem = $('<li />')
            .addClass('ct-series-' + letters[i])
            .html(val)
            .appendTo($chart_pensions_legend);
      });

      $chart_pensions.on('mouseenter', '.ct-slice-donut', function() {
        var $slice = $(this),
            classes = $slice.parent().attr('class').split(' '),
            last = classes.slice(-1)[0];
            $chart_pensions_legend.find('.'+last).addClass('hover');
      });
      $chart_pensions.on('mouseleave', '.ct-slice-donut', function() {
        $chart_pensions_legend.find('li.hover').removeClass('hover');
      });

      $chart_pensions_legend.on('mouseenter', 'li', function() {
        var $item = $(this),
            last = $item.attr('class');
        addClass($chart_pensions.find('.'+last +' .ct-slice-donut'), 'hover');
      });
      $chart_pensions_legend.on('mouseleave', 'li', function() {
        removeClass($chart_pensions.find('.hover'), 'hover');
      });

    })();
  }


  // Investment shares
  if($('.chart-investment-shares').length) {
    (function(){
      var investment_shares_labels = [
              '<span>41,4 %</span><br><span>Korkosijoitukset</span>',
              '<span>37,4 %</span><br><span>Osakesijoitukset</span>',
              '<span>12,1 %</span><br><span>Kiinteistösijoitukset</span>',
              '<span>9,5 %</span><br><span>Muut sijoitukset</span>'
            ];

    	if($('body.sv').length) {
    		investment_shares_labels = [
              '<span>41,4 %</span><br><span>Ränteplaceringar</span>',
              '<span>37,4 %</span><br><span>Aktieplacerinar</span>',
              '<span>12,1 %</span><br><span>Fastighetsplaceringar</span>',
              '<span>9,5 %</span><br><span>Övriga placeringar</span>'
            ];
    	}

      var $chart_investment_shares = $('.chart-investment-shares'),
          $chart_investment_shares_legend = $('.chart-investment-shares-legend');
          data = {
            labels: investment_shares_labels,
            series: [41.4, 37.4, 12.1, 9.5]
          };

      new Chartist.Pie('.chart-investment-shares', data,  {
        chartPadding: 10,
        donut: true,
        donutWidth: 30,
        showLabel: false
      });

      $.each(data.labels, function(i, val) {
        var listItem = $('<li />')
            .addClass('ct-series-' + letters[i])
            .html(val)
            .appendTo($chart_investment_shares_legend);
      });

      $chart_investment_shares.on('mouseenter', '.ct-slice-donut', function() {
        var $slice = $(this),
            classes = $slice.parent().attr('class').split(' '),
            last = classes.slice(-1)[0];
            $chart_investment_shares_legend.find('.'+last).addClass('hover');
      });
      $chart_investment_shares.on('mouseleave', '.ct-slice-donut', function() {
        $chart_investment_shares_legend.find('li.hover').removeClass('hover');
      });

  /*
      $chart_investment_shares_legend.on('mouseenter', 'li', function() {
        var $item = $(this),
            last = $item.attr('class');
        addClass($chart_investment_shares.find('.'+last +' .ct-slice'), 'hover');
      });
      $chart_investment_shares_legend.on('mouseleave', 'li', function() {
        removeClass($chart_investment_shares.find('.hover'), 'hover');
      });
  */
    })();
  }


  // Investment incomes
  if($('.chart-investments').length) {
    (function(){
      var data = {
        labels: ['1998', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016','2017', '21 v.(1)', '21 v.(2)'],
        series: [
          [8.8, 12.3, 2.3, 4.4, -0.9, 8.6, 11.4, 10.7, 10.8, 7.3, -15.5, 10.8, 11.5, -4.9, 11.3, 7.4, 6.5, 5.8, 6.6, 8.0, 6.2, 4.5]
        ]
      };

    	if($('body.sv').length) {
    		data.labels[19] = '21 år (1)';
    		data.labels[20] = '21 år (2)';
    	}

      var chart = new Chartist.Bar('.chart-investments', data, {
        fullWidth: true,
        axisX: {
          showGrid: false
        },
        axisY: {
          labelOffset: {
            y: 5
          }
        }
      }, [
        ['screen and (max-width: 595px)', {
          axisX: {
            labelInterpolationFnc: function(value, index) {
              return index % 2 === 0 ? value : null;
            }
          }
        }]
      ]);

      chart.on('draw', function(e) {
        drawBarValue(e, chart, "#3C750D", true);

        if(e.element._node.nodeName === 'text' && e.index  === 20) {
          e.element.attr({
            y: e.y + 13
          });

        }
      });
    })();
  }

  // Investment incomes
  if($('.chart-stableness').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [541.1, 595.9, 616.6, 681.6, 778.5]
        ]
      };
      var chart = new Chartist.Bar('.chart-stableness', data, {
        high: 1100,
        low: 0,
        axisX: {
          showGrid: false,
        },
        axisY: {
          labelOffset: {
            y: 5
          }
        }
      });

      chart.on('draw', function(event) {
        // If the draw event is for labels on the x-axis
        if(event.type === 'label' && event.axis.units.pos === 'x') {
          // If foreign object is NOT supported, we need to fallback to text-anchor and event.width / 2 offset.
          if(!chart.supportsForeignObject) {
            event.element.attr({
              x: event.x + event.width / 2,
              'text-anchor': 'middle'
            });
          }
        }
      });

      var extradata = {
        labels: data.labels,
        series: [
          [40.29, 52.71, 51.99, 50.28, 45.20],
          [10.13, 13.18, 13.00, 12.57, 11.30]
        ]
      };
      var extrachart = new Chartist.Line('.chart-stableness-extra', extradata, {
        high: 55,
        low: 0,
        lineSmooth: false,
        axisX: {
          showGrid: false,
          showLabel: false
        },
        axisY: {
          showGrid: false,
          showLabel: false
        }
      });
    })();
  }
  
  if($('.chart-stableness-count-teaser').length) {
    (function(){
      var data = {
        labels: ['2016', '2017'],
        series: [
          [681.6, 778.5]
        ]
      };
      var chart = new Chartist.Bar('.chart-stableness-count-teaser', data, {
        axisX: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        axisY: {
          showLabel: false,
          offset: 0
        },
        low: 600,
        chartPadding: 20
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", false);});
    })();
  }



  // Customer satisfaction
  if($('.chart-customer-sats').length) {
    (function(){
      var data = {
        labels: ['Hintataso', 'Asiakkaan tarpeet', 'Ongelma&shy;tilanteet', 'Asian&shy;tuntemus', 'Tavoitet&shy;tavuus', 'Yhteydenpito', 'Palvelu&shy;alttius', 'Lupausten pitäminen'],
        series: [
          [53, 67, 53, 82, 67, 51, 71, 78],
          [38, 45, 38, 75, 44, 8, 53, 62]
        ]
      };

    	if($('body.sv').length) {
    		data.labels = ['Prisnivå', 'Kundens behov', 'Problem&shy;situationer', 'Sakkunskap', 'Tillgäng&shy;lighet', 'Kontakt till kunden', 'Service&shy;villighet', 'Att hålla löften'];
    	}

    	if(!Modernizr.svgforeignobject) {
        $.each(data.labels, function(i, val) {
          data.labels[i] = val.replace('&shy;', '');
        });
    	}

      var chart = new Chartist.Line('.chart-customer-sats', data, {
        lineSmooth: false,
        axisX: {
          showGrid: false,
        },
        axisY: {
          labelOffset: {
            y: 5,
            x: -20
          },
          offset: 20
        },
        chartPadding: {
          right: 50,
          bottom: 25,
          left: 50
        },
        fullWidth: true
      }, [
        ['screen and (max-width: 595px)', {
          axisX: {
            labelInterpolationFnc: function(value, index) {
              return index % 2 === 0 ? value : null;
            }
          }
        }]
      ]);

      chart.on('draw', function(event) {
        // If the draw event is for labels on the x-axis
        if(event.type === 'label' && event.axis.units.pos === 'x') {

            event.element.attr({
              x: event.x + event.width / 2 - event.width,
              'text-anchor': 'middle',
            });

            if(event.element._node.nodeName === 'text' && event.index % 2 === 1) {
              event.element.attr({
                y: event.y + 20
              });

            }
        }
      });
    })();
  }


  // Maksetut eläkkeet
  if($('.chart-paid-pensions').length) {
    (function(){
      var data = {
        labels: ['2013', '2014', '2015', '2016', '2017'],
        series: [
          [432.0, 454.8, 463.8, 486.1, 489.9]
        ]
      };
      var chart = new Chartist.Bar('.chart-paid-pensions', data, {
        axisX: {
          showGrid: false
        }
      });

      chart.on('draw', function(e) { drawBarValue(e, chart, "#ffffff", true);});
    })();
  }
});
